import styled from 'styled-components';

import colors from '../../../../../chat/styles/colors';
import Button from '../../../../../chat/components/Button';
import SearchBar from '../../../../../chat/components/SearchBar';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 350px;
  max-width: 400px;
  border-right: 1px solid ${colors.shades.gamma4};
  height: 100%;
`;

const ListHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: ${colors.base.secondary2};
`;

const ListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
`;

const NoResultsOnPage = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 16px;
  color: ${colors.shades.gamma6};
`;

const StyledSearchBar = styled(SearchBar)`
  margin-top: 10px;

  .MuiTextField-root {
    margin: 0;
  }

  .MuiInputBase-root {
    height: 42px;
    padding-left: 10px;
  }
`;

const LoadMoreButton = styled(Button)`
  height: 40px;
  background: ${colors.shades.gamma5};
  color: ${colors.shades.gamma7};
  border: 1px solid ${colors.shades.gamma4};
  font-size: 12px;
  cursor: pointer;
`;

export {
  Container,
  ListHeader,
  ListItemsContainer,
  NoResultsOnPage,
  LoadMoreButton,
  StyledSearchBar,
};
